const User = {
  build,
};

function build() {
  return {
    __typename: "User",
    email: "",
    password: "",
  };
}

export default User;
